export default "__VITE_ASSET__DxKQTvth__"